import { DummyStore } from 'src/stores';

import { PaymentsResponse } from '../types';

export namespace SystemUserPaymentsStore {
  export const payments = new DummyStore<PaymentsResponse>();
}
